export default "__VITE_ASSET__c745895b__"